import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getUserFullNameFromEmail } from "../../../utils/functions/getUserFullNameFromEmail";
import Txt from "../../typography/Txt";

const CellRendererUserByEmail = (params) => {
  const users = useSelector((state) => state?.users);
  const userEmail = useMemo(() => {
    return params?.value;
  }, [params?.value]);

  const userNameFromEmail = useMemo(() => {
    return getUserFullNameFromEmail(users, userEmail);
  }, [userEmail, users]);

  return (
    <TextEllipsisWrapper stacked={params?.stacked}>
      <Txt sx={{ fontSize: "inherit" }}>{userNameFromEmail || "Unknown"}</Txt>
      {userEmail ? (
        <Txt
          secondary
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
            pl: 0.6,
            maxWidth: "100%",
          }}
        >
          {`<${userEmail}>`}
        </Txt>
      ) : null}
    </TextEllipsisWrapper>
  );
};
const TextEllipsisWrapper = ({
  children,
  multiLine = false,
  maxLines = 3,
  style,
  stacked = false,
  className,
  ...props
}) => {
  const ellipsisStyle = multiLine
    ? {
        // Multi-line ellipsis
        display: "-webkit-box",
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        wordWrap: "break-word",
      }
    : {
        // Single-line ellipsis
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        minWidth: 0,
        maxWidth: "100%",
      };

  const stackedStyle = stacked
    ? {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }
    : {};

  return (
    <div
      style={{
        ...ellipsisStyle,
        ...stackedStyle,
        ...style,
      }}
      className={className}
      {...props}
    >
      {children}
    </div>
  );
};
export default CellRendererUserByEmail;
